module.exports = __webpack_public_path__ + "static/media/cover_back.fd6d04d5.jpg";